module.exports = __webpack_public_path__ + "assets/img/58b66e7.899624fa.svg";